import {
    buttonContainer, header, headerName, metadataContainer,
} from '../styles/AudienceMetadata'

import {CopyButton} from './CopyButton'
import {MetadataHeaderViewProps} from '../types'
import React from 'react'
import {isObjectEmpty} from 'utils/props'
import {styled} from 'stitches/config'

const StyledMetadataContainer = styled('div', metadataContainer)
const StyledButtonContainer = styled('div', buttonContainer)
const StyledHeader = styled('div', {
    ...header,
    [`& ${StyledButtonContainer}`]: {visibility: 'visible'},
})
const StyledHeaderName = styled('div', headerName)


export const AudienceMetadataHeaderView = (props: MetadataHeaderViewProps): React.ReactElement => {
    const {
        values, text, Icon,
    } = props
    const haveMetadata = () => !isObjectEmpty(values)

    return (
        <>
            {haveMetadata() &&
            <StyledMetadataContainer>
                <StyledHeader>
                    <StyledHeaderName>
                        {!!Icon && <Icon />}
                        <span>{text}</span>
                    </StyledHeaderName>
                    <StyledButtonContainer>
                        <CopyButton currentKey='' currentValue={values} />
                    </StyledButtonContainer>
                </StyledHeader>
            </StyledMetadataContainer>}
            {}
        </>
    )
}
